import { useEffect, useRef, useState } from 'react';
import BotDialogBusyOverlay from 'components/BotDialog/BusyOverlay/BusyOverlay';
import { Root, Container, Title, Description } from './BotDialog.styles';
import { IconRoundedExclamationOutlined } from 'components/common/SVGIcons';

/**
 * Displays the Bot avatar and Dialog.
 * @param {string} title
 * @param {string} description
 * @param {node} children
 * @param {bool} [show=false] - indicates if the component should render.
 * @param {bool} [busy=false] - shows a spinner on top of its contents.
 */
export default function BotDialog({ title, description, children, show = false, busy = false }) {
  const [renderBasedOnTransition, setRenderBasedOnTransition] = useState(false);
  const refRoot = useRef();

  function handleAnimationEnd(ev) {
    if (ev.target === refRoot.current && !show) {
      setRenderBasedOnTransition(false);
    }
  }

  useEffect(() => {
    const entering = show && !renderBasedOnTransition;

    if (entering) {
      setRenderBasedOnTransition(true);
    }
  }, [show, renderBasedOnTransition]);

  if (!renderBasedOnTransition) {
    return;
  }

  return (
    <Root ref={refRoot} show={show} onAnimationEnd={handleAnimationEnd} role="tooltip" aria-busy={Boolean(busy)}>
      <Container>
        {title && (
          <Title>
            <IconRoundedExclamationOutlined width={14} height={15} aria-hidden={true} /> {title}
          </Title>
        )}
        {description && <Description children={description} />}
        {children}
        {Boolean(busy) && <BotDialogBusyOverlay aria-hidden={true} />}
      </Container>
      <img src="/images/avatars/business/business-bot-avatar.svg" width={40} height={40} alt="bot avatar" />
    </Root>
  );
}
